// extracted by mini-css-extract-plugin
module.exports = {"box":"styles_box__KuybM","button_box":"styles_button_box__2j0tv","btn":"styles_btn__3Xxz4","add_cart":"styles_add_cart__3IeY1","tips":"styles_tips__3_dZG"};